import React from "react";
import LoadingSpin from "../../components/LoadingSpin";
import ErrorMessage from "../../components/ErrorMessage";
import {BrowserRouter as Router, Redirect} from "react-router-dom";
import {Form, Col, InputGroup, Button, ButtonGroup, Image} from "react-bootstrap";
import {config} from "../../components/Constants";
import DefaultAvatar from "../../../assets/images/avatar.png";
import BlankImage from "../../../assets/images/blank.gif";

class UsersEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            submitError: null,
            isLoaded: true,
            isLoggedIn: false,
            isSubmitting: false,
            redirect: null,
            validated: false,
            privileges: [],
            user: false
        };
        this.handleSubmitForm = this.handleSubmitForm.bind(this);
        this.handleReturn = this.handleReturn.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.setAvatar = this.setAvatar.bind(this);
    }

    componentDidMount() {
        if(this.props.match.params.id) {
            fetch(config.API_URL + '/api/users/edit/' + this.props.match.params.id, {
                credentials: 'include'
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result.error) {
                            this.setState({
                                user: null,
                                isLoaded: true,
                                privileges: [],
                                error: result.error
                            });
                        } else if (result) {
                            this.setState({
                                user: result.user,
                                privileges: result.privileges,
                                isLoaded: true
                            });
                        }
                    },
                    (error) => {
                        this.setState({
                            user: null,
                            privileges: [],
                            isLoaded: true,
                            error: error
                        });
                    }
                );
        } else {
            fetch(config.API_URL + '/api/users/privileges', {
                credentials: 'include'
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        let user = {
                            name: '',
                            surname: '',
                            id: null
                        };
                        if (result.error) {
                            this.setState({
                                user: user,
                                isLoaded: true,
                                privileges: [],
                                error: result.error
                            });
                        } else if (result) {
                            this.setState({
                                user: user,
                                privileges: result.privileges,
                                isLoaded: true
                            });
                        }
                    },
                    (error) => {
                        this.setState({
                            user: null,
                            privileges: [],
                            isLoaded: true,
                            error: error
                        });
                    }
                );
        }
    }

    handleSubmitForm(event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        const form = event.currentTarget;
        if (form.checkValidity() !== false) {
            this.setState({
                isSubmitting: true
            });
            const formData = new FormData(event.target);
            let data = {};
            formData.forEach((val, mkey) => {
                data[mkey] = val;
            });
            fetch(config.API_URL + '/api/users/update', {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                'method': 'POST',
                'body': JSON.stringify(data)
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result.error) {
                            this.setState({
                                isSubmitting: false,
                                submitError: result.error
                            });
                        } else if (result) {
                            this.props.updateStateHandler({
                                user: result.user,
                                avatar: result.user.avatar
                            });
                            this.setState({
                                isSubmitting: false,
                                redirect: '/users'
                            });
                        }
                    },
                    (error) => {
                        this.setState({
                            isSubmitting: false,
                            submitError: error
                        });
                    }
                );
        }
        this.setState({
            validated: true,
        });
        return false;
    }

    handleReturn(event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        this.setState({
            redirect: '/users'
        });
        return false;
    }

    handlePasswordChange(event) {
        if (event) {
            let checkbox = event.target;
            let passwordInput = document.getElementsByClassName('password');
            for (let x = 0; x < passwordInput.length; x++) {
                if (checkbox.checked) {
                    passwordInput[x].setAttribute('required', 'required');
                    passwordInput[x].setAttribute('placeholder', 'Wprowadź hasło');
                    passwordInput[x].removeAttribute('disabled');
                } else {
                    passwordInput[x].setAttribute('disabled', 'disabled');
                    passwordInput[x].removeAttribute('required');
                    passwordInput[x].removeAttribute('placeholder');
                }
            }
        }
    }

    setAvatar(event){
        const types = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const maxFileSize = 300;
        if(event){
            let fileInput = event.target;
            if(fileInput.files && fileInput.files.length > 0){
                if(fileInput.files.length > 1){
                    this.setState({
                        submitError: 'Można wstawić tylko jeden plik!'
                    });
                } else {
                    let file = fileInput.files[0];
                    if(types.every(type => file.type !== type)){
                        this.setState({
                            submitError: 'Nieprawidłowy typ pliku, dozwolone są tylko obrazy JPG, PNG oraz GIF'
                        });
                    } else {
                        if(file.size > (maxFileSize*1024)){
                            this.setState({
                                submitError: 'Przesłany plik jest za duży! Maksymalna wielkość pliku to '+maxFileSize+'kB'
                            });
                        } else {
                            let image = document.getElementById('usersAvatar');
                            let field = document.getElementById('avatarInputField');
                            let fieldName = document.getElementById('avatarFileName');
                            var reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = function (e) {
                                console.log(file);
                                image.style.backgroundImage = 'url('+e.target.result+')';
                                field.value = e.target.result;
                                fieldName.value = file.name;
                            }
                        }
                    }
                }
            }
        }
    }
    render() {
        const {error, isLoaded, isLoggedIn, isSubmitting, submitError, redirect, user, privileges, validated} = this.state;
        const that = this;
        if (!isLoaded || user === false) {
            return (
                <LoadingSpin/>
            );
        } else if (redirect !== null) {
            return <Redirect to={redirect}/>
        } else if (user === null) {
            return (
                <ErrorMessage title="Pojawiły się błędy" text={'Nie znaleziono administratora o ID: ' + this.props.match.params.id} buttons={[
                    {
                        'title': 'Powrót', 'callback': function () {
                            that.setState({redirect: '/users', user: {}});
                        }
                    }
                ]} handleClose={() => {
                    that.setState({redirect: '/users', user: {}});
                }}/>
            );
        } else if (error) {
            return (
                <ErrorMessage title="Pojawiły się błędy" text={error} buttons={[
                    {
                        'title': 'Powrót', 'callback': function () {
                            that.setState({redirect: '/users', error: null});
                        }
                    }
                ]} handleClose={() => {
                    that.setState({redirect: '/users', error: null});
                }}/>
            );
        } else {
            let avatar = DefaultAvatar;
            if(user && user.avatarImage){
                avatar = user.avatarImage;
            }
            return (
                <React.Fragment>
                    {isSubmitting ? <LoadingSpin/> : ''}
                    <header className="clients-header">
                        {user.id ?
                            <h1>Edycja użytkownika: {user.name + ' ' + user.surname}</h1>
                            :
                            <h1>Dodawanie nowego użytkownika</h1>
                        }
                    </header>
                    <div className="section-div">
                        {submitError !== null ? <ErrorMessage title="Pojawiły się błędy" text={submitError} buttons={[
                            {
                                'title': 'OK', 'callback': function () {
                                    that.setState({submitError: null});
                                }
                            }
                        ]} handleClose={() => {
                            that.setState({submitError: null});
                        }}/> : ''}
                        <Form method="post" noValidate validated={validated} onSubmit={this.handleSubmitForm}>
                            <Form.Control type="hidden" defaultValue={user.id} name="id"/>
                            <Form.Control type="hidden" name="avatar" id="avatarInputField"/>
                            <Form.Control type="hidden" name="avatarFileName" id="avatarFileName"/>
                            <h2>Konto:</h2>
                            <Form.Row>
                                <Form.Group  as={Col} sm={12} controlId="formGridLogin">
                                    <Form.Label className="avatarUpload">
                                        <Image src={BlankImage} style={{
                                            backgroundImage: 'url('+avatar+')'
                                        }} id="usersAvatar"></Image>
                                        <Form.Control name="avatarFile" type="file" onChange={this.setAvatar}/>
                                    </Form.Label>
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} md={4} sm={12} controlId="formGridLogin">
                                    <Form.Label>
                                        Login:
                                    </Form.Label>
                                    <Form.Control defaultValue={user.login} name="login" type="text" placeholder="Login użytkownika" required={true}/>
                                    <Form.Control.Feedback type="invalid">
                                        Login jest wymagany
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md={4} sm={12} controlId="formGridPasswd">
                                    <Form.Label>
                                        Hasło:
                                    </Form.Label>
                                    {user.id ?
                                        <InputGroup>
                                            <InputGroup.Prepend>
                                                <InputGroup.Text id="inputGroupPrepend">
                                                    <Form.Check name="changepass" value="1" onChange={this.handlePasswordChange}/>
                                                </InputGroup.Text>
                                            </InputGroup.Prepend>
                                            <Form.Control name="pass" type="password" className="password" aria-describedby="inputGroupPrepend" disabled/>
                                            <Form.Control.Feedback type="invalid">
                                                Należy podać hasło
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                        :
                                        <InputGroup>
                                            <Form.Control name="pass" type="password" placeholder="Wprowadź hasło" required={true}/>
                                            <Form.Control.Feedback type="invalid">
                                                Należy podać hasło
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    }
                                </Form.Group>
                                <Form.Group as={Col} md={4} sm={12} controlId="formGridPasswd">
                                    <Form.Label>
                                        Uprawnienia:
                                    </Form.Label>
                                    <Form.Control as="select" name="privileges_id" type="text" placeholder="Wprowadź hasło" required={true} defaultValue={user.privileges_id}>
                                        {privileges.map((priv, mkey) => {
                                            return (
                                                <option value={priv.id} key={mkey}>{priv.name}</option>
                                            );
                                        })}
                                    </Form.Control>
                                </Form.Group>
                            </Form.Row>
                            <h2>Dane podstawowe:</h2>
                            <Form.Row>
                                <Form.Group as={Col} md={4} sm={12} controlId="formGridName">
                                    <Form.Label>
                                        Imię:
                                    </Form.Label>
                                    <Form.Control defaultValue={user.name} name="name" type="text" placeholder="Imię" required={true}/>
                                    <Form.Control.Feedback type="invalid">
                                        Imię jest wymagane
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md={4} sm={12} controlId="formGridPasswd">
                                    <Form.Label>
                                        Nazwisko:
                                    </Form.Label>
                                    <Form.Control defaultValue={user.surname} name="surname" type="text" placeholder="Nazwisko" required={true}/>
                                    <Form.Control.Feedback type="invalid">
                                        Nazwisko jest wymagane
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md={4} sm={12} controlId="formGridPasswd">
                                    <Form.Label>
                                        Adres e-mail:
                                    </Form.Label>
                                    <Form.Control defaultValue={user.email} name="email" type="email" placeholder="Adres e-mail" required={true}/>
                                    <Form.Control.Feedback type="invalid">
                                        Adres e-mail jest wymagany
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>
                            <div className="downbuttons">
                                <Button type="submit" name="submit">Zapisz</Button> <Button onClick={this.handleReturn}>Powrót</Button>
                            </div>
                        </Form>
                    </div>
                </React.Fragment>
            );
        }
    }
}

export default UsersEdit;